var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss3SvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "CSS3",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#264de4",
    d: "M72 460L30 0h451l-41 460-184 52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2965f1",
    d: "M256 37V472l149-41 35-394"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "m114 94h142v56H119m5 58h132v57H129m3 28h56l4 45 64 17v59L139 382"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m256 208v57h69l-7 73-62 17v59l115-32 26-288H256v56h80l-5.5 58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3SvgrepoCom);
export default __webpack_public_path__ + "static/media/css3-svgrepo-com.c56383af0fc7fa213642ae1fc5fa4b29.svg";
export { ForwardRef as ReactComponent };